<template>
  <v-container fluid>
    <v-breadcrumbs class="fadeIn breadcrumb" :items="[
      {
        text: 'HOME',
        disabled: false,
        to: {name: 'home'},
        exact: true
      },
      {
        text: 'GESTIÓN',
        disabled: true
      }
    ]">
      <v-icon slot="divider">chevron_right</v-icon>
    </v-breadcrumbs>

    <v-layout wrap pt-3>
        <v-tabs vertical background-color="transparent"
          class="transparentTabs" >
          <v-tab v-for="(item, index) in items" :key="index + '-tab'" @change="pruebuca(item.name)">
            <v-row justify="center" align="center" :class="item.name === 'INMUEBLES' || item.name === 'OPERACIONES' ? 'pt-2' : ''">
              <v-col cols="12" class="pb-0 mb-0">
                {{ item.name }}
              </v-col>
              <v-col cols="12" class="pt-0 pb-0 mt-2 mb-0 px-0" v-if="item.name === 'INMUEBLES' || item.name === 'OPERACIONES'">
                <v-divider class="pt-0 pb-0 mt-2 mb-0 px-0"></v-divider>
              </v-col>
            </v-row>
          </v-tab>
          <v-tab-item v-for="(item, index) in items" :key="index + '-tab-item'">
            <v-container fluid>
              <keep-alive>
                <component :is="item.tipo"/>
              </keep-alive>
              
            </v-container>
          </v-tab-item>
        </v-tabs>
    </v-layout>
    
  </v-container>
</template>


<script>
import { mapActions } from 'vuex'
import sociedades from '../gestion/childs/sociedades'
import promociones from '../gestion/childs/promociones'
import proveedores from '../gestion/childs/proveedores'
import inmuebles from '../gestion/childs/inmuebles'
import clientes from '../gestion/childs/clientes'
import operaciones from '../gestion/childs/operaciones'
import tiposInmueble from '../gestion/childs/tiposInmueble'
/*import tiposVisita from '../gestion/childs/tiposVisita'
import urgencias from '../gestion/childs/urgencias'
import estadosIncidencias from '../gestion/childs/estadosIncidencias' */

export default {
  components: {
    sociedades,
    promociones,
    proveedores,
    inmuebles,
    clientes,
    operaciones,
    tiposInmueble,
    /* tiposVisita,
    urgencias,
    estadosIncidencias */
  },
  computed: {
    localization () {
      return this.$t('gestion')
    },
    items () {
      return [
        {
          name: this.localization.sociedades.title,
          link: '/gestion/sociedades',
          tipo: 'sociedades'
        },
        {
          name: this.localization.promociones.title,
          link: '/gestion/promociones',
          tipo: 'promociones'
        },
        {
          name: this.localization.tiposInmueble.title,
          link: '/gestion/tipos-de-inmueble',
          tipo: 'tiposInmueble'
        },
         {
          name: this.localization.inmuebles.title,
          link: '/gestion/inmuebles',
          tipo: 'inmuebles'
        },
        {
          name: this.localization.clientes.title,
          link: '/gestion/clientes',
          tipo: 'clientes'
        },
        {
          name: this.localization.operaciones.title,
          link: '/gestion/operaciones',
          tipo: 'operaciones'
        },
        {
          name: this.localization.proveedores.title,
          link: '/gestion/proveedores',
          tipo: 'proveedores'
        },
        /*{
          name: this.localization.tiposVisita.title,
          link: '/gestion/tipos-de-visita',
          tipo: 'tiposVisita'
        },
        {
          name: this.localization.urgencias.title,
          link: '/gestion/urgencias',
          tipo: 'urgencias'
        },
        {
          name: this.localization.estadosIncidencias.title,
          link: '/gestion/estados-incidencias',
          tipo: 'estadosIncidencias'
        }, */
      ]
    }
  },
  methods: {
    ...mapActions({
      getComponenteSeleccionado: 'gestion/getComponenteSeleccionado',
    }),
    goTo (routeName) {
      this.$router.push({name: routeName})
    },
    pruebuca(ev){
      this.getComponenteSeleccionado(ev)
      console.log('entro al log', ev);
    }
  }
}
</script>

<style>
.v-icon.v-icon.v-icon--link {
  display: flex !important;
}
.clickable {
  cursor: pointer;
}
</style>


